module.exports = __webpack_public_path__ + "img/05.5a9a1b25.jpg";